import { render, staticRenderFns } from "./StripeNotice.vue?vue&type=template&id=b5b7fcb8&scoped=true&"
import script from "./StripeNotice.vue?vue&type=script&lang=js&"
export * from "./StripeNotice.vue?vue&type=script&lang=js&"
import style0 from "./StripeNotice.vue?vue&type=style&index=0&id=b5b7fcb8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5b7fcb8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VCardText } from 'vuetify/lib/components/VCard';
installComponents(component, {VAlert,VCardText})
